import { httpClient } from '@/services/http/httpClient'

type CompleteWorkflowTaskParams = {
  ideaId: string
  taskId: string
  completed?: boolean
}

export async function completeWorkflowTask({
  ideaId,
  taskId,
  completed,
}: CompleteWorkflowTaskParams): Promise<void> {
  await httpClient.put(`/ideas/funnel/steps/${taskId}/complete`, {
    ideaId,
    completed,
  })
}
